export const LIVE_CHAT_ANCHOR_ID = 'live-chat-anchor';

export const LIVE_CHAT_HELP_BUTTON_SELECTOR = '.embeddedServiceHelpButton';

export const LIVE_CHAT_HELP_BUTTON_DISABLED_SELECTOR = '.embeddedServiceHelpButton .helpButton .uiButton.helpButtonDisabled';

export const getLiveChatAnchor = () => document.getElementById(LIVE_CHAT_ANCHOR_ID);

export const getLiveChatButton = () => document.querySelector<HTMLElement>(LIVE_CHAT_HELP_BUTTON_SELECTOR);
